// Widget Engine
// Handles rendering and updating of dynamic widgets

class WidgetEngine {
    constructor(containerId) {
        this.container = document.getElementById(containerId);
        this.widgets = {}; // Map of active widgets: { widgetId: { config, template, element } }
        this.templates = {}; // Map of available templates

        // Load templates from global if available
        if (window.WIDGET_TEMPLATES) {
            window.WIDGET_TEMPLATES.forEach(t => {
                this.templates[t.id] = t;
            });
        }
    }

    /**
     * Initializes the engine with a list of widget configurations
     * @param {Array} widgetConfigs - List of widget definitions from DB/JSON
     */
    init(widgetConfigs) {
        if (!this.container) {
            console.error('Widget container not found');
            return;
        }
        
        this.container.innerHTML = ''; // Clear existing
        this.widgets = {};

        widgetConfigs.forEach(config => {
            this.createWidget(config);
        });
    }

    /**
     * Creates and appends a single widget
     */
    createWidget(config) {
        const template = this.templates[config.templateId];
        if (!template) {
            console.warn(`Template not found: ${config.templateId}`);
            return;
        }

        // 1. Generate HTML with unique IDs
        let html = template.html;
        
        // Replace {{uid}}
        html = html.replace(/{{uid}}/g, config.id);
        
        // Replace static placeholders if any (e.g. title)
        if(config.title) {
            html = html.replace(/{{title}}/g, config.title);
        } else {
            html = html.replace(/{{title}}/g, template.name);
        }

        // 2. Create Wrapper Element
        const wrapper = document.createElement('div');
        // Grid classes can be customized. Defaulting to responsive grid.
        wrapper.className = 'col-md-6 col-xl-4 mb-4'; 
        wrapper.id = `widget-wrapper-${config.id}`;
        wrapper.innerHTML = html;

        // 3. Append to Container
        this.container.appendChild(wrapper);

        // 4. Register Widget
        this.widgets[config.id] = {
            config: config,
            template: template,
            wrapper: wrapper
        };

        // 5. Initial Render Call (empty data)
        if (template.renderer && template.renderer.onUpdate) {
            template.renderer.onUpdate(config.id, {}, wrapper);
        }
    }

    /**
     * Called when new data arrives from WebSocket/Hub
     * @param {Object} tagData - Key-Value map of { "Tag_Name": Value }
     */
    updateTags(tagData) {
        Object.keys(this.widgets).forEach(widgetId => {
            const widget = this.widgets[widgetId];
            const config = widget.config;
            const template = widget.template;

            // Map global tags to local template keys
            // Config.tags example: { "v1": "Analizor1.Voltaj_L1", "total_power": "Analizor1.Guc" }
            const mappedData = {};
            let hasUpdate = false;

            if (config.tags && template.slots) {
                template.slots.forEach(slot => {
                    const globalTagName = config.tags[slot.key];
                    if (globalTagName && tagData.hasOwnProperty(globalTagName)) {
                        mappedData[slot.key] = tagData[globalTagName];
                        hasUpdate = true;
                    }
                });
            }

            // Only run renderer if relevant data changed
            if (hasUpdate && template.renderer && template.renderer.onUpdate) {
                template.renderer.onUpdate(widgetId, mappedData, widget.wrapper);
            }
        });
    }
}

// Export
if (typeof module !== 'undefined' && module.exports) {
    module.exports = WidgetEngine;
} else {
    window.WidgetEngine = WidgetEngine;
}
